/**
 * Re-exports the ManuallyAddPlayerModal Container as the default export.
 * @module components/ManuallyAddPlayerModal
 */

export { default } from "./ManuallyAddPlayerModalContainer";
export type {
  IManuallyAddPlayerForm,
  ManuallyAddPlayerModalContainerProps,
} from "@/types/manuallyAddPlayerModalTypes";
